//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import comicobject from '../script/comicobject'

export default {
  mixins: [comicobject],
  name: "comiclist",
  data() {
    return {
      comic_list: undefined,
      comic_rows: [],
      manhua_conf: undefined,
      ROW_COUNT: this._g.COMMON_ROW_COUNT,
      g: this._g,
      comin_list_error_mark: false,
      page: 1,
      total_page: undefined,
      country: undefined,
      page_title: undefined
    }
  },
  watch: {
    "g.COMMON_ROW_COUNT": {
      handler(new_value, old_value) {
        console.log("_g.COMMON_ROW_COUNT:", new_value, old_value);
        this.ROW_COUNT = this._g.COMMON_ROW_COUNT;
        if (this.comic_list) {
          this.comic_rows = this.do_comic_list(this.comic_list.datas, this.ROW_COUNT);
        }
      },
      immediate: true,
    },
    page: {
      immediate: true,
      handler(new_value, old_value) {
        console.log("watch page:", new_value, old_value);
        if (this.country) {
          //this.load_comic_list();
        }
      },
    },
    '$route'(to, from) {
      if (this.country) {
        this.load_comic_list();
      }
    }
  }
  ,
  created() {
    window._t = this;
    this.load_comic_list();
  }
  ,
  methods: {
    on_pagination_input: function (e) {
      console.log("on_pagination_input:", e);
      if (e) {
        this.page = e;
      }
      var new_url = this.update_url_param({
        'page': e
      })
      console.log("new_url:", new_url);
      this.go(new_url);
    },
    load_comic_list: function () {

      this.comic_list = undefined;
      this.comic_rows = undefined;

      var url_vars = this.getUrlVars();
      this.country = url_vars.c;
      this.page = parseInt(url_vars.page);


      if (!this.page) {
        this.page = 1;
      }

      if (this.country != undefined) {
        var manhua_conf = this.get_manhua_by_country(this.country);
        console.log("manhua_conf:", manhua_conf);
        this.manhua_conf = manhua_conf;
        this.page_title = manhua_conf.name;
      } else {
        this.page_title = '所有漫画';
      }

      this.set_title(this.page_title);

      this.get_comic_datas({
        country: this.country,
        start: (this.page - 1) * this._g.PER_PAGE_COUNT,
        limit: this._g.PER_PAGE_COUNT,
        cb: this.on_comic_list,
        error_cb: this.on_comic_list_error
      });
    },
    on_comic_list: function (comic_list) {
      console.log("on_comic_list:", comic_list)
      this.comic_list = comic_list;
      this.comic_rows = this.do_comic_list(this.comic_list.datas, this.ROW_COUNT);
      this.total_page = parseInt(this.comic_list.total_count / this._g.PER_PAGE_COUNT) + 1;
    }
    ,
    on_comic_list_error: function () {
      this.comin_list_error_mark = true;
    }
  }
}
